const replace = (input) => {
  if(!input){
    return null;
  }
  return input.replace(/\[(.*?)\]\((.*?)\)/gim, '<a href=\'$1\' target=\'_blank\'>$2</a>');
};

export default replace;
